module.exports = __webpack_public_path__ + "static/media/Historia.fd350662.jpg";